import React from "react";
import { createPortal } from "react-dom";
import { LAYERS, T } from "../../app/tokens.js";

const MESSAGES = {
  error: "Some non-USD project amounts are unavailable because FX rates could not be loaded.",
  loading: "Loading FX rates…",
  partial: "* Some approved-budget amounts are unavailable because their FX rate is missing.",
};

// Portfolio notices are outside the header's layout flow: neither a hidden
// message nor independent FX/project arrival may move the toolbar or scan band.
// Active messages remain persistent, readable and wrapped, including on phones.
// Other lenses retain their existing inline notice.
export function ProjectsFxStatus({ loading, error, partial, floating = false }) {
  const state = error ? "error" : loading ? "loading" : partial ? "partial" : null;
  if (!state) return null;
  const notice = (
    <div
      data-testid="projects-fx-status"
      role={error ? "alert" : "status"}
      style={{
        color: error ? T.red : T.mid, fontSize: T.fsXs,
        ...(floating ? {
          // Leave the existing bottom-corner feedback control reachable.
          position: "fixed", bottom: 84, right: 24,
          width: "max-content", maxWidth: "min(560px, calc(100vw - 48px))",
          boxSizing: "border-box", padding: "10px 14px",
          background: T.white, border: `1px solid ${T.border}`,
          borderRadius: T.radiusCard, boxShadow: T.listCardShadow,
          zIndex: LAYERS.stickyChrome + 1,
        } : { marginTop: -6, marginBottom: 6 }),
      }}
    >
      {MESSAGES[state]}
    </div>
  );
  // The shell isolates its scrollport; a fixed descendant can still be hidden
  // behind the expanded rail on phones. Keep viewport notices outside it.
  return floating ? createPortal(notice, document.body) : notice;
}
